var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 6.31859C8.94277 6.31859 10.1163 5.09704 10.1163 3.59679C10.1163 2.09654 8.94277 0.875 7.49998 0.875C6.05719 0.875 4.8837 2.09654 4.8837 3.59679C4.8837 5.09704 6.05719 6.31859 7.49998 6.31859Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0349 7.46724C13.1086 7.46724 13.9828 6.55853 13.9828 5.4415C13.9828 4.32448 13.1086 3.41504 12.0349 3.41504C10.9611 3.41504 10.0869 4.32448 10.0869 5.4415C10.0869 6.55853 10.9611 7.46724 12.0349 7.46724Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96509 7.46724C4.03881 7.46724 4.913 6.55853 4.913 5.4415C4.913 4.32448 4.03881 3.41504 2.96509 3.41504C1.89137 3.41504 1.01718 4.32448 1.01718 5.4415C1.01718 6.55853 1.89137 7.46724 2.96509 7.46724Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50001 6.68164C5.28489 6.68164 3.48837 8.54988 3.48837 10.8551V11.5809C3.48837 11.8814 3.72279 12.1252 4.01163 12.1252H10.9884C11.2772 12.1252 11.5116 11.8814 11.5116 11.5809V10.8551C11.5116 8.54988 9.71513 6.68164 7.50001 6.68164Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96512 8.13281C1.33047 8.13281 0 9.51621 0 11.2175C0 11.7176 0.391396 12.1248 0.872095 12.1248H2.80466C2.57721 11.7575 2.44186 11.3235 2.44186 10.8546C2.44186 9.86315 2.71186 8.93774 3.17163 8.14588C3.10326 8.1408 3.03489 8.13281 2.96512 8.13281Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0349 8.13281C11.9651 8.13281 11.8967 8.1408 11.8284 8.14588C12.2881 8.93774 12.5581 9.86315 12.5581 10.8546C12.5581 11.3235 12.4228 11.7575 12.1953 12.1248H14.1279C14.6086 12.1248 15 11.7176 15 11.2175C15 9.51621 13.6695 8.13281 12.0349 8.13281Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKids);
export default __webpack_public_path__ + "static/media/icon-kids.113a131c3808d344f415b174c811b7e4.svg";
export { ForwardRef as ReactComponent };